module.exports = __webpack_public_path__ + "media/images/icons/user-1-b3d496fe35b097791c12dd7450649286.svg";